import {toggleClass} from "./utils";

function bind(el, root) {
  var min = el.getAttribute("data-chars-min");
  var max = el.getAttribute("data-chars-max");
  var underMsg = el.getAttribute("data-chars-message-under");
  var overMsg = el.getAttribute("data-chars-message-over");
  var display = el.getAttribute("data-chars-display");
  var displayEl = display && root.querySelector("#" + display);
  var displayText = displayEl && displayEl.innerHTML;
  var first = true;

  function validate() {
    var len = el.value.length;
    var under = min && (len < min);
    var over = max && (len > max);
    var invalid = under || over;
    if(displayEl) toggleClass(displayEl, "fail", invalid);
    if(displayText) displayEl.innerHTML = displayText.replace(/\d+\s*\//, len + "/");
    if(!first) el.setCustomValidity(under ? underMsg : over ? overMsg : "");
    first = false;
  }

  el.addEventListener("keyup", validate);
  validate();
}

function bindAll(root) {
  var els = root.querySelectorAll("[data-chars-min],[data-chars-max]");
  for(var i = 0; i < els.length; i++) bind(els[i], root);
}

$(function() { bindAll(document); });

window.AJAXTreeCallback = bindAll;
